export default __webpack_public_path__ + "event-summary-blob-2.svg";